import { Component, EventEmitter, Input, Output } from '@angular/core';
import { LanguageService } from '@hazmatsuite-next/ui';
import { Observable, map } from 'rxjs';
import { Store } from '@ngrx/store';
import { CompositePackagingModel } from '../../../models/composite-packaging.model';
import { OverPackagingModel } from '../../../models/over-packaging.model';
import { EnumPackageType } from '../../../models/package-type.enum';
import { Packages } from '../../../models/packages.interface';
import { SinglePackagingModel } from '../../../models/single-packaging.model';

@Component({
  selector: 'lib-easydgd-over-packaging-item',
  templateUrl: './over-packaging-item.component.html',
  styleUrls: ['./over-packaging-item.component.scss'],
})
export class OverPackagingItemComponent {
  @Input() item!: OverPackagingModel;
  @Input() compositePackagingItems: CompositePackagingModel[] = [];
  @Input() singlePackagingItems: SinglePackagingModel[] = [];
  @Input() overPackagingItems: OverPackagingModel[] = [];
  @Input() isLast = false;
  @Input() showPrintLabel = true;

  @Output() editSinglePackage = new EventEmitter<SinglePackagingModel>();
  @Output() removeSinglePackage = new EventEmitter<SinglePackagingModel>();
  @Output() duplicateSinglePackage = new EventEmitter<SinglePackagingModel>();
  @Output() editCompositePackage = new EventEmitter<CompositePackagingModel>();
  @Output() removeCompositePackage = new EventEmitter<CompositePackagingModel>();
  @Output() duplicateCompositePackage = new EventEmitter<CompositePackagingModel>();
  @Output() editPackage = new EventEmitter<OverPackagingModel>();
  @Output() remove = new EventEmitter<OverPackagingModel>();
  @Output() duplicate = new EventEmitter<OverPackagingModel>();

  packageTypes = EnumPackageType;
  collapsed = false;
  showOverpackModal = false;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public packingListResource$: Observable<any> = this.languageService.translations$.pipe(
    map(translations => translations['PackingListResource']));

  constructor(private languageService: LanguageService, private store: Store<{ packageList: { packages: Packages } }>) { }

  removePackage(): void {
    this.remove.emit(this.item);
  }

  copyPackage(): void {
    this.duplicate.emit(this.item);
  }

  edit(): void {
    this.showOverpackModal = true;
  }

  closeOverpackageModal(data: { packageId: string, pkg: OverPackagingModel, isEdit: boolean }) {
    this.showOverpackModal = false;
    this.editPackage.emit(data?.pkg);
  }
}
